import React,{useState,useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { Button,Table,Container,Row,Col,Form } from 'react-bootstrap';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';


function Master_Issuer_List(){  
    const navigate = useNavigate();
    const [isMsgBox,setMsgBox] = useState(false); 
    const [msgText,setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [issuerData, setIssuerData] = useState([]);
    const [showAddEditForm,setAddEditFormShow] = useState(false);
    const [showAddNewBtn,setShowAddNewBtn] = useState(true);

    const [srNo,setSrNo] = useState(0);
    const [issuer,setIssuer] = useState("");
    
    const [status,setStatus] = useState(0);
    const [ddActiveOptions,setDdActiveOptions] = useState([]);

    const [userRight,setUserRight] = useState([]);

    useEffect(()=>{
        if(onceRun){
            return;
        }else{
            setDdActiveOptions([{name:'Active',value:"1"},{name:'Inactive',value:"0"}]);
            Common.callApi(Common.apiRight,[sid,'all','ISSUER'],function(result){
                let resp = JSON.parse(result);
                if(resp.query==="1"){
                    setUserRight(resp);
                }else{
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiIssuer,[sid,'listjson'],function(result){ 
                setIssuerData(JSON.parse(result));
            });
            setOnceRun(true);
        }
    },[onceRun,sid,navigate]);

    function getList(){
        Common.callApi(Common.apiIssuer,[sid,'listjson'],function(result){ 
            setIssuerData(JSON.parse(result));
        });
    }

    function addNew(){
        setSrNo(0);
        setIssuer("");
        setStatus(1);
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

    function saveData(){
        if(issuer===""){
            setMsgText(Common.getMessage("MSG0006"));
            setMsgBox(true);
        } else {
            var object1 = {
                srno: srNo,
                issuer: issuer,
                act: status
            };
            Common.callApi(Common.apiIssuer,[sid,'save',srNo,JSON.stringify(object1)],function(result){ 
                let resp = JSON.parse(result);
                if(resp.err===""){
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    getList();
                }else{
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function cancelData(){
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
    }

    function fillEditForm(id){
        Common.callApi(Common.apiIssuer,[sid,'detail',id],function(result){ 
            let resp = JSON.parse(result);
            setSrNo(resp.srno);
            setIssuer(resp.issuer);
            setStatus(resp.active);
            setAddEditFormShow(true);
            setShowAddNewBtn(false); 
        });
    }
    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
                <Container fluid >
                    <Row>
                        <Col>
                            <h1>Issuer Master</h1>
                        </Col>  
                    </Row>
                    {showAddNewBtn?
                        <Row>
                            <Col>
                                {userRight.add==="1"?
                                    <Button  variant="outline-primary" size="sm"  onClick={addNew}>Add New</Button>             
                                :null}   
                            </Col>
                        </Row>
                    :null
                    }

                    <Row><Col>&nbsp;</Col></Row>
                    {showAddEditForm?
                    <Row>
                        <Col className="divContentCenter">
                             {/*Add Edit Form  className="mb-3" className="divContentCenter" */  }
                                <div className="maxFormWidth">
                                    <Form>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Serial Number</Form.Label>
                                                    <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                                </Form.Group>                                        
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>issuer<span className="mandatory">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="issuer" maxLength={50}
                                                    value={issuer} onChange={(e)=>setIssuer(e.target.value)}  autoComplete="off"/>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Select 
                                                        value={status}
                                                        onChange={(e)=>setStatus(e.target.value)}
                                                        >
                                                        {ddActiveOptions.map((res)=>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                        <Row>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button  variant="outline-success" size="sm"  onClick={()=>saveData()}>Save</Button>&nbsp;
                                                <Button  variant="outline-danger" size="sm"  onClick={()=>cancelData()}>Cancel</Button>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                    </Form>
                                </div>
                        </Col>
                    </Row>
                    :<>
                        <Row>
                            <Col >
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.edit==="1"? <th></th> :null}
                                            <th className="textRight">Sr No</th>
                                            <th >Issuer</th>
                                            <th >Status</th>
                                        </tr>
                                    </thead>
                                    <tbody id="tblBody">
                                    {issuerData.map((res) => 
                                        <tr key={res.issuer_id}>
                                            {userRight.edit==="1"?
                                                <td className="textCenter" >
                                                    <span className="handCursor" onClick={()=>fillEditForm(res.issuer_id) } >
                                                        <div className="colorThemeBlue"><FontAwesomeIcon icon={faEdit}  /></div>
                                                    </span>
                                                </td>
                                               :null
                                            }
                                            <td className="textRight">{res.issuer_id}</td>
                                            <td>{res.issuer_name}</td>
                                            <td>{res.issuer_active}</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                    }


                </Container>
                <div>
                    <Dialog isOpen={isMsgBox} onClose={(e)=> setMsgBox(false) }>
                        {msgText}
                    </Dialog>
                </div>
        </>
    );
}
export default Master_Issuer_List;